module.exports = __webpack_public_path__ + "img/kw.41603662.svg";